import katex from 'katex';
import 'katex/contrib/mhchem';

// Renders $...$ / $$...$$ and \(...\) / \[...\] LaTeX segments inside a
// string as KaTeX HTML, leaving everything else (including any existing
// rich-text HTML from the editor) untouched. Use this - not a plain
// pass-through - anywhere question/answer/explanation/option content is
// displayed to a user, or LaTeX shows up as raw "$...$" text instead of
// rendered math. Mirrors the same delimiters the backend's PDF generation
// recognizes (app/utils/latex_pdf.py) - keep both in sync.
export const renderMathHtml = (text: string | null | undefined): string => {
  if (!text) return '';
  return text.replace(/(\$\$[\s\S]+?\$\$|\$[^$\n]+?\$|\\\[[\s\S]+?\\\]|\\\([^\n]+?\\\))/g, (match) => {
    let isBlock: boolean;
    let formula: string;
    if (match.startsWith('$$')) {
      isBlock = true;
      formula = match.slice(2, -2).trim();
    } else if (match.startsWith('$')) {
      isBlock = false;
      formula = match.slice(1, -1).trim();
    } else if (match.startsWith('\\[')) {
      isBlock = true;
      formula = match.slice(2, -2).trim();
    } else {
      isBlock = false;
      formula = match.slice(2, -2).trim();
    }
    if (!formula) return match;
    try {
      return katex.renderToString(formula, { throwOnError: false, displayMode: isBlock });
    } catch {
      return match;
    }
  });
};
